









import { Component, Prop, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component
export default class Progress extends Vue {
  @Prop() step !: string

  get roundClass () {
    return this.step
  }
}
